import { SVGProps } from 'react'

export const BurgerIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="14"
    viewBox="0 0 20 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1 7H19M1 1H19M1 13H19"
      stroke="#364359"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)
